import * as t from  './actionTypes';
import * as api from './api';

export function loadFriends() {

  return (dispatch) => {
    dispatch({ type: t.SET_BUSY });

    api.getFriends((success, friends, error) => {
      if (success) {
        dispatch({ type: t.FRIEND_LOAD_SUCCESS, friends: friends });
        dispatch({ type: t.UNSET_BUSY });
      } else if (error) {
        dispatch({ type: t.UNSET_BUSY });

      }
    });
  }
}

export function createNewFriend(data, successCB, errorCB) {
  return (dispatch) => {
    dispatch({ type: t.SET_BUSY });

    api.createNewFriend(data, function(success, data, error) {
      if (success) {
        dispatch({ type: t.FRIEND_CREATE_SUCCESS, friend: data });
        dispatch({ type: t.UNSET_BUSY });
        successCB();
      } else if (error) {
        dispatch({ type: t.UNSET_BUSY });
        errorCB(error);
      }
    })
  }
}

export function editFriend(id, data, successCB, errorCB) {
  return (dispatch) => {
    dispatch({ type: t.SET_BUSY });

    api.editFriend(id, data, function(success, data, error) {
      if (success) {
        dispatch({ type: t.FRIEND_EDIT_SUCCESS, id: id, friend: data });
        dispatch({ type: t.UNSET_BUSY });
        successCB();
      } else if (error) {
        dispatch({ type: t.UNSET_BUSY });
        errorCB(error);
      }
    })
  }
}

export function archiveFriendOffer(id, data, CB) {
  return (dispatch) => {
    dispatch({ type: t.SET_BUSY });
    api.archiveFriendOffer(id, data, function(success, data, error) {
      dispatch({ type: t.UNSET_BUSY });
      CB();     
    })
  }
}

export function deleteFriend(id, successCB, errorCB) {
  return (dispatch) => {
    dispatch({ type: t.SET_BUSY });

    api.deleteFriend(id, function(success, error) {
      if (success) {
        dispatch({ type: t.FRIEND_DELETE_SUCCESS, id: id });
        dispatch({ type: t.UNSET_BUSY });
        successCB();
      } else if (error) {
        dispatch({ type: t.UNSET_BUSY });
        errorCB(error);
      }
    })
  }
}
